'use strict';

function square(number) {
    return Math.pow(number, 2);
}

function hypotenuse(x, y) {
    return Math.sqrt(square(x) + square(y));
}

function absDistance(number1, number2) {
    return Math.abs(number1 - number2);
}

function getTouchDistance(position1, position2) {
    const { x: x1, y: y1 } = position1;
    const { x: x2, y: y2 } = position2;

    return hypotenuse(absDistance(x1, x2), absDistance(y1, y2));
}

function touchToCoordinates(target, touch) {
    return {
        x: touch.pageX - target.offsetLeft,
        y: touch.pageY - target.offsetTop,
    };
}

module.exports = {
    square,
    hypotenuse,
    absDistance,
    getTouchDistance,
    touchToCoordinates,
};



// WEBPACK FOOTER //
// ./assets/js/global/utils/touch/utils.es.js